import React from 'react';
import { useNode } from '@craftjs/core';
import { TextField, FormControl, FormLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  input: {
    margin: theme.spacing(1, 0),
    cursor: 'pointer',
    '&:hover': {
      outline: '2px solid #2196f3',
    },
  },
  settings: {
    padding: theme.spacing(2),
  },
}));

export const Input = ({ 
  label, 
  placeholder, 
  type, 
  required, 
  fullWidth, 
  helperText,
  variant,
  size
}) => {
  const classes = useStyles();
  const { connectors: { connect, drag } } = useNode();

  return (
    <TextField
      ref={(ref) => connect(drag(ref))}
      className={classes.input}
      label={label}
      placeholder={placeholder}
      type={type}
      required={required}
      fullWidth={fullWidth}
      helperText={helperText}
      variant={variant}
      size={size}
    />
  );
};

const InputSettings = () => {
  const classes = useStyles();
  const {
    actions: { setProp },
    label,
    placeholder,
    type,
    required,
    fullWidth,
    helperText,
    variant,
    size,
  } = useNode((node) => ({
    label: node.data.props.label,
    placeholder: node.data.props.placeholder,
    type: node.data.props.type,
    required: node.data.props.required,
    fullWidth: node.data.props.fullWidth,
    helperText: node.data.props.helperText,
    variant: node.data.props.variant,
    size: node.data.props.size,
  }));

  return (
    <div className={classes.settings}>
      <FormControl fullWidth margin="normal">
        <FormLabel>Etiqueta</FormLabel>
        <TextField
          value={label}
          onChange={(e) => setProp((props) => (props.label = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Placeholder</FormLabel>
        <TextField
          value={placeholder}
          onChange={(e) => setProp((props) => (props.placeholder = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Tipo de campo</FormLabel>
        <TextField
          select
          value={type}
          onChange={(e) => setProp((props) => (props.type = e.target.value))}
          SelectProps={{
            native: true,
          }}
        >
          <option value="text">Texto</option>
          <option value="email">Email</option>
          <option value="password">Contraseña</option>
          <option value="number">Número</option>
          <option value="tel">Teléfono</option>
          <option value="url">URL</option>
        </TextField>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Variante</FormLabel>
        <TextField
          select
          value={variant}
          onChange={(e) => setProp((props) => (props.variant = e.target.value))}
          SelectProps={{
            native: true,
          }}
        >
          <option value="outlined">Con borde</option>
          <option value="filled">Relleno</option>
          <option value="standard">Estándar</option>
        </TextField>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Tamaño</FormLabel>
        <TextField
          select
          value={size}
          onChange={(e) => setProp((props) => (props.size = e.target.value))}
          SelectProps={{
            native: true,
          }}
        >
          <option value="small">Pequeño</option>
          <option value="medium">Mediano</option>
        </TextField>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Texto de ayuda</FormLabel>
        <TextField
          value={helperText}
          onChange={(e) => setProp((props) => (props.helperText = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={required}
            onChange={(e) => setProp((props) => (props.required = e.target.checked))}
            style={{ marginRight: 8 }}
          />
          Campo requerido
        </FormLabel>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={fullWidth}
            onChange={(e) => setProp((props) => (props.fullWidth = e.target.checked))}
            style={{ marginRight: 8 }}
          />
          Ancho completo
        </FormLabel>
      </FormControl>
    </div>
  );
};

Input.craft = {
  props: {
    label: 'Campo de texto',
    placeholder: 'Escribe aquí...',
    type: 'text',
    required: false,
    fullWidth: true,
    helperText: '',
    variant: 'outlined',
    size: 'medium',
  },
  related: {
    settings: InputSettings,
  },
};
